// component
import React from 'react';
import {
  DashboardIcon,
  VideoIcon,
  LabelIcon,
  UserIcon,
  AqualabelToolIcon
} from 'components/icon/DashboardIcon';

// ----------------------------------------------------------------------

const sidebarConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: <DashboardIcon />,
    group: ['MASTER', 'REVIEWER', 'VIEW_ONLY'],
    newTab: false,
    chip: false
  },
  {
    title: 'Add video',
    path: '/dashboard/video',
    icon: <VideoIcon />,
    group: ['MASTER'],
    newTab: false,
    chip: false
  },
  {
    title: 'Aqualabel tool',
    path: 'https://aqualabeltool.pttep.com',
    icon: <AqualabelToolIcon />,
    group: ['MASTER'],
    newTab: true,
    chip: false
  },
  {
    title: 'User',
    path: '/dashboard/user',
    icon: <UserIcon />,
    group: ['MASTER'],
    newTab: false,
    chip: false
  },
  {
    title: 'Fish classification',
    path: '/dashboard/label',
    icon: <LabelIcon />,
    group: ['REVIEWER'],
    newTab: false,
    chip: true
  }
];

export default sidebarConfig;
